
<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">Filtrar por</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form ref="ruleForm">
          <div class="lg:mb-2">
            <div>
              <base-collapsible class="mb-3" customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{$t('app.dates')}}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                        <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.disposition_date_from')}}
                          <el-form-item prop="fechaDisposicionDesde">
                              <el-date-picker
                                :clearable="false"
                                class="bg-white dark:bg-darkblue-900"
                                v-model="form.fechaDisposicionDesde.value"
                                type="date"
                                format="dd-MM-yyyy"
                                :picker-options="dateRangeOptions"
                                placeholder="dd-mm-aaaa"
                                ref="datePickerFechaDisposicionDesde"
                                @blur="onBlurDatePickerMixin('.datePickerFechaDisposicionDesde-popover')"
                                @focus="onFocusDatePickerMixin('.datePickerFechaDisposicionDesde-popover')"
                                @keydown.native="captureKeyNotChrome"
                                popper-class="datePickerFechaDisposicionDesde-popover"
                                >
                              </el-date-picker>
                              <base-clear-input-button
                                v-if="form.fechaDisposicionDesde.value"
                                aria-label="Limpiar fecha"
                                @clear="form.fechaDisposicionDesde.value = null"
                              />
                          </el-form-item>
                        </label>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.disposition_date_to')}}
                        <el-form-item prop="fechaDisposicionHasta">
                            <el-date-picker
                              :clearable="false"
                              class="bg-white dark:bg-darkblue-900"
                              v-model="form.fechaDisposicionHasta.value"
                              :picker-options="dateRangeOptions"
                              type="date"
                              format="dd-MM-yyyy"
                              placeholder="dd-mm-aaaa"
                              ref="datePickerFechaDisposicionHasta"
                              @blur="onBlurDatePickerMixin('.datePickerFechaDisposicionHasta-popover')"
                              @focus="onFocusDatePickerMixin('.datePickerFechaDisposicionHasta-popover')"
                              @keydown.native="captureKeyNotChrome"
                              popper-class="datePickerFechaDisposicionHasta-popover"
                              >
                            </el-date-picker>
                            <base-clear-input-button
                              v-if="form.fechaDisposicionHasta.value"
                              aria-label="Limpiar fecha"
                              @clear="form.fechaDisposicionHasta.value = null"
                            />
                        </el-form-item>
                      </label>
                    </div>
                  </div>
                  <div>
                    <div>
                        <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.download_date_from')}}
                          <el-form-item prop="fechaDescargaDesde">
                              <el-date-picker
                                :clearable="false"
                                class="bg-white dark:bg-darkblue-900"
                                v-model="form.fechaDescargaDesde.value"
                                :picker-options="dateRangeOptions"
                                type="date"
                                format="dd-MM-yyyy"
                                placeholder="dd-mm-aaaa"
                                ref="datePickerFechaDescargaDesde"
                                @blur="onBlurDatePickerMixin('.datePickerFechaDescargaDesde-popover')"
                                @focus="onFocusDatePickerMixin('.datePickerFechaDescargaDesde-popover')"
                                @keydown.native="captureKeyNotChrome"
                                popper-class="datePickerFechaDescargaDesde-popover"
                                >
                              </el-date-picker>
                            <base-clear-input-button
                              v-if="form.fechaDescargaDesde.value"
                              aria-label="Limpiar fecha"
                              @clear="form.fechaDescargaDesde.value = null"
                            />
                          </el-form-item>
                        </label>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.download_date_to')}}
                        <el-form-item prop="fechaDescargaHasta">
                            <el-date-picker
                              :clearable="false"
                              class="bg-white dark:bg-darkblue-900"
                              v-model="form.fechaDescargaHasta.value"
                              :picker-options="dateRangeOptions"
                              type="date"
                              format="dd-MM-yyyy"
                              placeholder="dd-mm-aaaa"
                              ref="datePickerFechaDescargaHasta"
                              @blur="onBlurDatePickerMixin('.datePickerFechaDescargaHasta-popover')"
                              @focus="onFocusDatePickerMixin('.datePickerFechaDescargaHasta-popover')"
                              @keydown.native="captureKeyNotChrome"
                              popper-class="datePickerFechaDescargaHasta-popover"
                              >
                            </el-date-picker>
                            <base-clear-input-button
                              v-if="form.fechaDescargaHasta.value"
                              aria-label="Limpiar fecha"
                              @clear="form.fechaDescargaHasta.value = null"
                            />
                        </el-form-item>
                      </label>
                    </div>
                  </div>
                  <div>
                    <div>
                        <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.end_date_from')}}
                          <el-form-item prop="fechaFinTramiteDesde">
                              <el-date-picker
                                :clearable="false"
                                class="bg-white dark:bg-darkblue-900"
                                v-model="form.fechaFinTramiteDesde.value"
                                :picker-options="dateRangeOptions"
                                type="date"
                                format="dd-MM-yyyy"
                                placeholder="dd-mm-aaaa"
                                ref="datePickerFechaFinTramiteDesde"
                                @blur="onBlurDatePickerMixin('.datePickerFechaFinTramiteDesde-popover')"
                                @focus="onFocusDatePickerMixin('.datePickerFechaFinTramiteDesde-popover')"
                                @keydown.native="captureKeyNotChrome"
                                popper-class="datePickerFechaFinTramiteDesde-popover"
                                >
                              </el-date-picker>
                            <base-clear-input-button
                              v-if="form.fechaFinTramiteDesde.value"
                              aria-label="Limpiar fecha"
                              @clear="form.fechaFinTramiteDesde.value = null"
                            />
                          </el-form-item>
                        </label>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.end_date_to')}}
                        <el-form-item prop="fechaFinTramiteHasta">
                            <el-date-picker
                              :clearable="false"
                              class="bg-white dark:bg-darkblue-900"
                              v-model="form.fechaFinTramiteHasta.value"
                              :picker-options="dateRangeOptions"
                              type="date"
                              format="dd-MM-yyyy"
                              placeholder="dd-mm-aaaa"
                              ref="datePickerFechaFinTramiteHasta"
                              @blur="onBlurDatePickerMixin('.datePickerFechaFinTramiteHasta-popover')"
                              @focus="onFocusDatePickerMixin('.datePickerFechaFinTramiteHasta-popover')"
                              @keydown.native="captureKeyNotChrome"
                              popper-class="datePickerFechaFinTramiteHasta-popover"
                              >
                            </el-date-picker>
                            <base-clear-input-button
                              v-if="form.fechaFinTramiteHasta.value"
                              aria-label="Limpiar fecha"
                              @clear="form.fechaFinTramiteHasta.value = null"
                            />
                        </el-form-item>
                      </label>
                    </div>
                  </div>
                  
                  <div>
                    <div>
                        <span id="notif-filter-fecha-registro-desde-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.registro_date_from')}}</span>
                          <el-form-item prop="fechaHoraRegistroDesde">
                              <el-date-picker
                                :clearable="false"
                                class="bg-white dark:bg-darkblue-900"
                                v-model="form.fechaHoraRegistroDesde.value"
                                :picker-options="dateRangeOptions"
                                type="date"
                                format="dd-MM-yyyy"
                                placeholder="dd-mm-aaaa"
                                aria-labelledby="notif-filter-fecha-registro-desde-label"
                                ref="datePickerfechaHoraRegistroDesde"
                                @blur="onBlurDatePickerMixin('.datePickerfechaHoraRegistroDesde-popover')"
                                @focus="onFocusDatePickerMixin('.datePickerfechaHoraRegistroDesde-popover')"
                                @keydown.native="captureKeyNotChrome"
                                popper-class="datePickerfechaHoraRegistroDesde-popover"
                                >
                              </el-date-picker>
                            <base-clear-input-button
                              v-if="form.fechaHoraRegistroDesde.value"
                              aria-label="Limpiar fecha"
                              @clear="form.fechaHoraRegistroDesde.value = null"
                            />
                          </el-form-item>
                    </div>
                    <div>
                      <span id="notif-filter-fecha-registro-hasta-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.registro_date_to')}}</span>
                        <el-form-item prop="fechaHoraRegistroHasta">
                            <el-date-picker
                              :clearable="false"
                              class="bg-white dark:bg-darkblue-900"
                              v-model="form.fechaHoraRegistroHasta.value"
                              :picker-options="dateRangeOptions"
                              type="date"
                              format="dd-MM-yyyy"
                              placeholder="dd-mm-aaaa"
                              aria-labelledby="notif-filter-fecha-registro-hasta-label"
                              ref="datePickerfechaHoraRegistroHasta"
                              @blur="onBlurDatePickerMixin('.datePickerfechaHoraRegistroHasta-popover')"
                              @focus="onFocusDatePickerMixin('.datePickerfechaHoraRegistroHasta-popover')"
                              @keydown.native="captureKeyNotChrome"
                              popper-class="datePickerfechaHoraRegistroHasta-popover"
                              >
                            </el-date-picker>
                            <base-clear-input-button
                              v-if="form.fechaHoraRegistroHasta.value"
                              aria-label="Limpiar fecha"
                              @clear="form.fechaHoraRegistroHasta.value = null"
                            />
                        </el-form-item>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>

            <div>
              <base-collapsible class="mb-3" customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{$t('notificationFilter.metadatos')}}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <AccessibleElSelect
                        v-model="form.metadato1.value.campo"
                        prop="metadatoCampo1"
                        :options="valuesCamposMetadatosForAccessibleSelect"
                      >
                        <template slot="label">
                          <base-obligatory-icon v-if="form.metadato1.value.valor || form.metadato1.value.campo"/>
                          {{$t('notificationFilter.metadato_campo')}}
                        </template>
                      </AccessibleElSelect>
                    </div>
                    <div>
                      <div class="flex justify-between items-center mb-2">
                        <label class="w-full flex flex-row items-center justify-between text-sm font-semibold text-secondary-600 mb-1">
                          <div>
                            <base-obligatory-icon v-if="form.metadato1.value.valor || form.metadato1.value.campo"/>
                            {{$t('notificationFilter.operator')}}
                          </div>
                          <base-select v-model="form.metadato1.value.operador" :data="operators" size="tinyxs" ariaLabel="Operador metadato 1"/>
                        </label>
                      </div>

                      <AccessibleElSelect
                        v-if="form.metadato1.value.operador === 1 && (this.role === 'UsuarioConsulta' || this.role === 'Usuario' || this.role === 'Administrador')"
                        v-model="form.metadato1.value.valor"
                        prop="metadatoValor1"
                        :options="valoresMetadato1ActualForAccessibleSelect"
                        :allowCreate="true"
                        :placeholder="'Seleccione o escriba'"
                      >
                        <template slot="label">
                          <base-obligatory-icon v-if="form.metadato1.value.valor || form.metadato1.value.campo"/>
                          {{$t('notificationFilter.metadato_valor')}}
                        </template>
                      </AccessibleElSelect>
                      <div v-else-if="form.metadato1.value.operador !== 4 && form.metadato1.value.operador !== 5">
                        <span id="trash-notif-filter-metadato1-value" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="form.metadato1.value.valor || form.metadato1.value.campo"/> {{$t('notificationFilter.metadato_valor')}}</span>
                        <el-input
                          aria-labelledby="trash-notif-filter-metadato1-value"
                          class="w-full"
                          v-model="form.metadato1.value.valor"
                          maxlength="100"
                          placeholder="Valor del metadato"
                        >
                          <template v-if="form.metadato1.value.valor" slot="suffix">
                            <base-clear-input-button
                              class="pt-2"
                              aria-label="Limpiar campo del valor del metadato"
                              @clear="form.metadato1.value.valor = ''"
                            />
                          </template>
                        </el-input>
                      </div>

                    </div>

                    <div v-if="form.metadato1.value.campo && (form.metadato1.value.valor || form.metadato1.value.operador === 4 || form.metadato1.value.operador === 5)" 
                      class="border-primary-300 dark:border-darkblue-600 border-t pt-4">
                      <div>
                        <AccessibleElSelect
                          v-model="form.metadato2.value.campo"
                          prop="metadatoCampo2"
                          :options="valuesCamposMetadatosForAccessibleSelect"
                        >
                          <template slot="label">
                            <base-obligatory-icon v-if="form.metadato2.value.valor || form.metadato2.value.campo"/>
                            {{$t('notificationFilter.metadato_campo')}}
                          </template>
                        </AccessibleElSelect>
                      </div>
                      <div>
                        <div class="flex justify-between items-center mb-2">
                          <label class="w-full flex flex-row items-center justify-between text-sm font-semibold text-secondary-600 mb-1">
                            <div>
                              <base-obligatory-icon v-if="form.metadato2.value.valor || form.metadato2.value.campo"/>
                              {{$t('notificationFilter.operator')}}
                            </div>
                            <base-select v-model="form.metadato2.value.operador" :data="operators" size="tinyxs" ariaLabel="Operador metadato 2"/>
                          </label>
                        </div>

                        <AccessibleElSelect
                          v-if="form.metadato2.value.operador === 1 && (this.role === 'UsuarioConsulta' || this.role === 'Usuario' || this.role === 'Administrador')"
                          v-model="form.metadato2.value.valor"
                          prop="metadatoValor2"
                          :options="valoresMetadato2ActualForAccessibleSelect"
                          :allowCreate="true"
                          :placeholder="'Seleccione o escriba'"
                        >
                          <template slot="label">
                            <base-obligatory-icon v-if="form.metadato2.value.valor || form.metadato2.value.campo"/>
                            {{$t('notificationFilter.metadato_valor')}}
                          </template>
                        </AccessibleElSelect>
                        <div v-else-if="form.metadato2.value.operador !== 4 && form.metadato2.value.operador !== 5">
                          <span id="trash-notif-filter-metadato2-value" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="form.metadato2.value.valor || form.metadato2.value.campo"/> {{$t('notificationFilter.metadato_valor')}}</span>
                          <el-input
                            aria-labelledby="trash-notif-filter-metadato2-value"
                            class="w-full"
                            v-model="form.metadato2.value.valor"
                            maxlength="100"
                            placeholder="Valor del metadato"
                          >
                            <template v-if="form.metadato2.value.valor" slot="suffix">
                              <base-clear-input-button
                                class="pt-2"
                                aria-label="Limpiar campo del valor del metadato"
                                @clear="form.metadato2.value.valor = ''"
                              />
                            </template>
                          </el-input>
                        </div>
                      </div>
                    </div>
                    <div v-if="form.metadato2.value.campo && (form.metadato2.value.valor || form.metadato2.value.operador === 4 || form.metadato2.value.operador === 5)" class="border-primary-300 dark:border-darkblue-600 border-t pt-4">
                      <div>
                        <AccessibleElSelect
                          v-model="form.metadato3.value.campo"
                          prop="metadatoCampo3"
                          :options="valuesCamposMetadatosForAccessibleSelect"
                        >
                          <template slot="label">
                            <base-obligatory-icon v-if="form.metadato3.value.valor || form.metadato3.value.campo"/>
                            {{$t('notificationFilter.metadato_campo')}}
                          </template>
                        </AccessibleElSelect>
                      </div>
                    <div>
                      <div class="flex justify-between items-center mb-2">
                        <label class="w-full flex flex-row items-center justify-between text-sm font-semibold text-secondary-600 mb-1">
                          <div>
                            <base-obligatory-icon v-if="form.metadato3.value.valor || form.metadato3.value.campo"/>
                            {{$t('notificationFilter.operator')}}
                          </div>
                          <base-select v-model="form.metadato3.value.operador" :data="operators" size="tinyxs" ariaLabel="Operador metadato 3"/>
                        </label>
                      </div>

                      <AccessibleElSelect
                        v-if="form.metadato3.value.operador === 1 && (this.role === 'UsuarioConsulta' || this.role === 'Usuario' || this.role === 'Administrador')"
                        v-model="form.metadato3.value.valor"
                        prop="metadatoValor3"
                        :options="valoresMetadato3ActualForAccessibleSelect"
                        :allowCreate="true"
                        :placeholder="'Seleccione o escriba'"
                      >
                        <template slot="label">
                          <base-obligatory-icon v-if="form.metadato3.value.valor || form.metadato3.value.campo"/>
                          {{$t('notificationFilter.metadato_valor')}}
                        </template>
                      </AccessibleElSelect>
                      <div v-else-if="form.metadato3.value.operador !== 4 && form.metadato3.value.operador !== 5">
                        <span id="trash-notif-filter-metadato3-value" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="form.metadato3.value.valor || form.metadato3.value.campo"/> {{$t('notificationFilter.metadato_valor')}}</span>
                        <el-input
                          aria-labelledby="trash-notif-filter-metadato3-value"
                          class="w-full"
                          v-model="form.metadato3.value.valor"
                          maxlength="100"
                          placeholder="Valor del metadato"
                        >
                          <template v-if="form.metadato3.value.valor" slot="suffix">
                            <base-clear-input-button
                              class="pt-2"
                              aria-label="Limpiar campo del valor del metadato"
                              @clear="form.metadato3.value.valor = ''"
                            />
                          </template>
                        </el-input>
                      </div>
                    </div>
                    </div>
                    <div v-if="form.metadato3.value.campo && (form.metadato3.value.valor || form.metadato3.value.operador === 4|| form.metadato3.value.operador === 5)" class="border-primary-300 dark:border-darkblue-600 border-t pt-4">
                      <div>
                        <AccessibleElSelect
                          v-model="form.metadato4.value.campo"
                          prop="metadatoCampo4"
                          :options="valuesCamposMetadatosForAccessibleSelect"
                        >
                          <template slot="label">
                            <base-obligatory-icon v-if="form.metadato4.value.valor || form.metadato4.value.campo"/>
                            {{$t('notificationFilter.metadato_campo')}}
                          </template>
                        </AccessibleElSelect>
                      </div>
                    <div>
                      <div class="flex justify-between items-center mb-2">
                        <label class="w-full flex flex-row items-center justify-between text-sm font-semibold text-secondary-600 mb-1">
                          <div>
                            <base-obligatory-icon v-if="form.metadato4.value.valor || form.metadato4.value.campo"/>
                            {{$t('notificationFilter.operator')}}
                          </div>
                          <base-select v-model="form.metadato4.value.operador" :data="operators" size="tinyxs" ariaLabel="Operador metadato 4"/>
                        </label>
                      </div>

                      <AccessibleElSelect
                        v-if="form.metadato4.value.operador === 1 && (this.role === 'UsuarioConsulta' || this.role === 'Usuario' || this.role === 'Administrador')"
                        v-model="form.metadato4.value.valor"
                        prop="metadatoValor4"
                        :options="valoresMetadato4ActualForAccessibleSelect"
                        :allowCreate="true"
                        :placeholder="'Seleccione o escriba'"
                      >
                        <template slot="label">
                          <base-obligatory-icon v-if="form.metadato4.value.valor || form.metadato4.value.campo"/>
                          {{$t('notificationFilter.metadato_valor')}}
                        </template>
                      </AccessibleElSelect>
                      <div v-else-if="form.metadato4.value.operador !== 4 && form.metadato4.value.operador !== 5">
                        <span id="trash-notif-filter-metadato4-value" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="form.metadato4.value.valor || form.metadato4.value.campo"/> {{$t('notificationFilter.metadato_valor')}}</span>
                        <el-input
                          aria-labelledby="trash-notif-filter-metadato4-value"
                          class="w-full"
                          v-model="form.metadato4.value.valor"
                          maxlength="100"
                          placeholder="Valor del metadato"
                        >
                          <template v-if="form.metadato4.value.valor" slot="suffix">
                            <base-clear-input-button
                              class="pt-2"
                              aria-label="Limpiar campo del valor del metadato"
                              @clear="form.metadato4.value.valor = ''"
                            />
                          </template>
                        </el-input>
                      </div>
                    </div>
                    </div>
                    <div v-if="form.metadato4.value.campo && (form.metadato4.value.valor || form.metadato4.value.operador === 4|| form.metadato4.value.operador === 5 )" class="border-primary-300 dark:border-darkblue-600 border-t pt-4">
                      <div>
                        <AccessibleElSelect
                          v-model="form.metadato5.value.campo"
                          prop="metadatoCampo5"
                          :options="valuesCamposMetadatosForAccessibleSelect"
                        >
                          <template slot="label">
                            <base-obligatory-icon v-if="form.metadato5.value.valor || form.metadato5.value.campo"/>
                            {{$t('notificationFilter.metadato_campo')}}
                          </template>
                        </AccessibleElSelect>
                      </div>
                    <div>
                      <div class="flex justify-between items-center mb-2">
                        <label class="w-full flex flex-row items-center justify-between text-sm font-semibold text-secondary-600 mb-1">
                          <div>
                            <base-obligatory-icon v-if="form.metadato5.value.valor || form.metadato5.value.campo"/>
                            {{$t('notificationFilter.operator')}}
                          </div>
                          <base-select v-model="form.metadato5.value.operador" :data="operators" size="tinyxs" ariaLabel="Operador metadato 5"/>
                        </label>
                      </div>

                      <AccessibleElSelect
                        v-if="form.metadato5.value.operador === 1 && (this.role === 'UsuarioConsulta' || this.role === 'Usuario' || this.role === 'Administrador')"
                        v-model="form.metadato5.value.valor"
                        prop="metadatoValor5"
                        :options="valoresMetadato5ActualForAccessibleSelect"
                        :allowCreate="true"
                        :placeholder="'Seleccione o escriba'"
                      >
                        <template slot="label">
                          <base-obligatory-icon v-if="form.metadato5.value.valor || form.metadato5.value.campo"/>
                          {{$t('notificationFilter.metadato_valor')}}
                        </template>
                      </AccessibleElSelect>
                      <div v-else-if="form.metadato5.value.operador !== 4 && form.metadato5.value.operador !== 5">
                        <span id="trash-notif-filter-metadato5-value" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="form.metadato5.value.valor || form.metadato5.value.campo"/> {{$t('notificationFilter.metadato_valor')}}</span>
                        <el-input
                          aria-labelledby="trash-notif-filter-metadato5-value"
                          class="w-full"
                          v-model="form.metadato5.value.valor"
                          maxlength="100"
                          placeholder="Valor del metadato"
                        >
                          <template v-if="form.metadato5.value.valor" slot="suffix">
                            <base-clear-input-button
                              class="pt-2"
                              aria-label="Limpiar campo del valor del metadato"
                              @clear="form.metadato5.value.valor = ''"
                            />
                          </template>
                        </el-input>
                      </div>
                    </div>
                     
                    </div>

                  </div>
                </template>
              </base-collapsible>
            </div>

            <div>
              <base-collapsible class="mb-3" customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{$t('app.advanced_search')}}</h2>
                  </div>
                </template>
                <template slot="content">

                <div>
                  <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.textoLibre')}}
                    <el-form-item prop="textoLibre">
                      <el-input
                        type="textarea"
                        :rows="3"
                        class="w-full"
                        v-model="form.textoLibre.value"
                        maxlength="500"
                      >
                      </el-input>
                    </el-form-item>
                  </label>
                </div>

                </template>
              </base-collapsible>
            </div>

            <div v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
              <base-collapsible class="mb-3" customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{$t('app.admin')}}</h2>
                  </div>
                </template>
                <template slot="content">

                  <div v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
                    <div v-if="role === 'SuperAdministrador'">
                      <AccessibleElSelect
                        v-model="form.distribuidor.value"
                        prop="distribuidor"
                        :options="distribuidoresForAccessibleSelect"
                        @select="handleSelectDistribuidor"
                      >
                        <template slot="label">{{$t('distributors.distributor')}}</template>
                      </AccessibleElSelect>
                    </div>

                    <AccessibleElSelect
                      v-model="form.empresa.value"
                      prop="empresa"
                      :options="clientesForAccessibleSelect"
                      @select="handleSelectCliente"
                    >
                      <template slot="label">{{$t('app.client')}}</template>
                    </AccessibleElSelect>
                  </div>

                </template>
              </base-collapsible>
            </div>

            <div>
              <base-collapsible 
                defaultOpen
                class="mb-3" 
                customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{$t('notificationFilter.neo_data')}}</h2>
                  </div>
                </template>
                <template slot="content">
            
                  <div>
                    <span id="trash-notif-filter-ticket-id-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.TicketID')}}</span>
                      <el-form-item prop="ticketId">
                        <el-input
                          aria-labelledby="trash-notif-filter-ticket-id-label"
                          class="w-full"
                          v-model="form.ticketId.value"
                          maxlength="150"
                        >
                        <template v-if="form.ticketId.value" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de TicketID"
                            @clear="form.ticketId.value = ''"
                          />
                        </template>
                      </el-input>
                      </el-form-item>
                  </div>

                  <div>
                    <AccessibleElSelect
                      v-model="form.codPGN.value"
                      prop="codPGN"
                      :options="sedesForAccessibleSelect"
                      :isMultiple="true"
                      @change="handleSelectSede"
                    >
                      <template slot="label">{{$t('app.location')}}</template>
                    </AccessibleElSelect>
                  </div>

                  <div>
                    <AccessibleElSelect
                      v-model="form.organismo.value"
                      prop="organismo"
                      :options="valuesOrganismosForAccessibleSelect"
                      :remote="true"
                      :remoteMethod="remoteOrganismos"
                      :loading="loadingOrganismos"
                      id-prefix="trashnotificationsfilter"
                      popperClass="wrap-select-popover"
                      @select="handleSelectOrganismo"
                    >
                      <template slot="label">
                        <div class="flex items-center gap-x-2">
                          {{$t('app.organismo')}}
                          <base-tooltip-icon size="sm" :content="'Escribe para iniciar la búsqueda'"/>
                        </div>
                      </template>
                    </AccessibleElSelect>
                  </div>

                  <div>
                    <span id="trash-notif-filter-nombre-cif-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.nombre_cif')}}</span>
                      <el-form-item prop="NombreCIF">
                        <el-input
                          aria-labelledby="trash-notif-filter-nombre-cif-label"
                          class="w-full"
                          v-model="form.NombreCIF.value"
                          maxlength="150"
                        >
                        <template v-if="form.NombreCIF.value" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de razón social"
                            @clear="form.NombreCIF.value = ''"
                          />
                        </template>
                      </el-input>
                      </el-form-item>
                  </div>

                  <div>
                    <span id="trash-notif-filter-cif-titular-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.CIFTitular')}}</span>
                      <el-form-item prop="cifTitular">
                        <el-input
                          aria-labelledby="trash-notif-filter-cif-titular-label"
                          class="w-full"
                          v-model="form.cifTitular.value"
                          maxlength="50"
                        >
                          <template v-if="form.cifTitular.value" slot="suffix">
                            <base-clear-input-button
                              aria-label="Limpiar campo del CIF del titular"
                              @clear="form.cifTitular.value = ''"
                            />
                          </template>
                        </el-input>
                      </el-form-item>
                  </div>
                  <div>
                    <span id="trash-notif-filter-cif-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.cif')}}</span>
                      <el-form-item prop="cif">
                        <el-input
                          aria-labelledby="trash-notif-filter-cif-label"
                          class="w-full"
                          v-model="form.cif.value"
                          maxlength="50"
                        >
                        <template v-if="form.cif.value.value" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo del CIF"
                            @clear="form.cif.value.value = ''"
                          />
                        </template>
                      </el-input>
                      </el-form-item>
                  </div>

                  <div>
                    <span id="trash-notif-filter-asunto-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.subject')}}</span>
                      <el-form-item prop="asunto">
                        <el-input
                          aria-labelledby="trash-notif-filter-asunto-label"
                          class="w-full"
                          v-model="form.asunto.value"
                          maxlength="500"
                        >
                        <template v-if="form.asunto.value" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo del asunto"
                            @clear="form.asunto.value = ''"
                          />
                        </template>
                      </el-input>
                      </el-form-item>
                  </div>

                  <div>
                    <AccessibleElSelect
                      v-model="form.tipoNotif.value"
                      prop="tipoNotif"
                      :options="typesForAccessibleSelect"
                      @select="handleSelectTipo"
                    >
                      <template slot="label">{{$t('notificationFilter.type')}}</template>
                    </AccessibleElSelect>
                  </div>

                  <div v-if="isGeneralStatus">
                    <AccessibleElSelect
                      v-model="form.estadoDescargaExtra.value"
                      prop="estadoDescargaExtra"
                      :options="tiposEstadoDescargaForAccessibleSelect"
                      :isMultiple="true"
                    >
                      <template slot="label">{{$t('notificationFilter.status')}}</template>
                    </AccessibleElSelect>
                  </div>

                  <div>
                    <AccessibleElSelect
                      v-model="form.DescargadaAutomaticamente.value"
                      prop="DescargadaAutomaticamente"
                      :options="archivadasForAccessibleSelect"
                    >
                      <template slot="label">{{$t('notificationFilter.descargada_automaticamente')}}</template>
                    </AccessibleElSelect>
                  </div>

                  <div>
                    <span id="trash-notif-filter-notas-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.notas')}}</span>
                      <el-form-item prop="notas">
                        <el-input
                          aria-labelledby="trash-notif-filter-notas-label"
                          class="w-full"
                          v-model="form.notas.value"
                          maxlength="500"
                        >
                        <template v-if="form.notas.value" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de notas"
                            @clear="form.notas.value = ''"
                          />
                        </template>
                      </el-input>
                      </el-form-item>
                  </div>

                  <div>
                    <AccessibleElSelect
                      v-model="form.altaManual.value"
                      prop="altaManual"
                      :options="archivadasForAccessibleSelect"
                    >
                      <template slot="label">{{$t('notificationFilter.alta_manual')}}</template>
                    </AccessibleElSelect>
                  </div>

                  <div>
                    <span id="trash-notif-filter-id-interno-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.internal_id')}}</span>
                      <el-form-item prop="idInterno">
                        <el-input
                          aria-labelledby="trash-notif-filter-id-interno-label"
                          class="w-full"
                          v-model="form.idInterno.value"
                          min="0"
                          max="9999999999"
                          type="number"
                        >
                        <template v-if="form.idInterno.value" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo del ID interno"
                            @clear="form.idInterno.value = ''"
                          />
                        </template>
                      </el-input>
                      </el-form-item>
                  </div>

                  <div v-if="ultimoErrorActive">
                    <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.errorTemporal')}}
                      <el-form-item prop="ultimoError">
                        <el-input
                          type="textarea"
                          :rows="3"
                          class="w-full"
                          v-model="form.ultimoError.value"
                          maxlength="500"
                        />
                      </el-form-item>
                    </label>
                  </div>

                </template>
              </base-collapsible>
            </div>

            <div>
              <base-collapsible class="mb-3" customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{$t('app.groups_attrs')}}</h2>
                  </div>
                </template>
                <template slot="content">

                  <div>
                    <AccessibleElSelect
                      v-model="form.nombreGrupo.value"
                      prop="nombreGrupo"
                      :options="listaGroupsGroupingForAccessibleSelect"
                      :group="true"
                    >
                      <template slot="label">{{$t('notificationFilter.group')}}</template>
                    </AccessibleElSelect>
                  </div>

                  <div>
                    <AccessibleElSelect
                      v-model="form.nombreGrupoPropietario.value"
                      prop="nombreGrupoPropietario"
                      :options="listaGroupsGroupingOwnerForAccessibleSelect"
                      :group="true"
                    >
                      <template slot="label">{{$t('notificationFilter.group_owner')}}</template>
                    </AccessibleElSelect>
                  </div>

                  <div>
                    <AccessibleElSelect
                      v-model="form.nombreGrupoPropietarioAnterior.value"
                      prop="nombreGrupoPropietarioAnterior"
                      :options="listaGroupsGroupingOwnerForAccessibleSelect"
                      :group="true"
                    >
                      <template slot="label">{{$t('notificationFilter.group_owner_last')}}</template>
                    </AccessibleElSelect>
                  </div>

                  <div>
                    <AccessibleElSelect
                      v-model="form.TieneGrupoReparto.value"
                      prop="TieneGrupoReparto"
                      :options="archivadasForAccessibleSelect"
                    >
                      <template slot="label">{{$t('notificationFilter.group_reparto')}}</template>
                    </AccessibleElSelect>
                  </div>

                  <div>
                    <AccessibleElSelect
                      v-model="form.soyPropietario.value"
                      prop="soyPropietario"
                      :options="archivadasForAccessibleSelect"
                    >
                      <template slot="label">{{$t('notificationFilter.soy_propietario')}}</template>
                    </AccessibleElSelect>
                  </div>

                  <div>
                    <span id="trash-notif-filter-usuario-responsable-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('app.user_responsable')}}</span>
                      <el-form-item prop="UsuarioResponsable">
                        <el-input
                          aria-labelledby="trash-notif-filter-usuario-responsable-label"
                          class="w-full"
                          v-model="form.UsuarioResponsable.value"
                          maxlength="100"
                        >
                          <template v-if="form.UsuarioResponsable.value" slot="suffix">
                            <base-clear-input-button
                              aria-label="Limpiar campo del usuario responsable"
                              @clear="form.UsuarioResponsable.value = ''"
                            />
                          </template>
                        </el-input>
                      </el-form-item>
                  </div>

                </template>
              </base-collapsible>
            </div>

            <div v-if="hasModuleAgrupaciones">
              <base-collapsible class="mb-3" customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{$t('app.grouping')}}</h2>
                  </div>
                </template>
                <template slot="content">

                <div v-if="hasModuleAgrupaciones">
                  <div>
                    <AccessibleElSelect
                      v-model="form.agrupacionCIF.value"
                      prop="agrupacionCIF"
                      :options="listGroupingEmpresasForAccessibleSelect"
                    >
                      <template slot="label">{{$t('grouping.neos_by_cif')}}</template>
                    </AccessibleElSelect>
                  </div>
                  <div>
                    <AccessibleElSelect
                      v-model="form.agrupacionSede.value"
                      prop="agrupacionSede"
                      :options="listGroupingSedesForAccessibleSelect"
                    >
                      <template slot="label">{{$t('grouping.neos_by_sede')}}</template>
                    </AccessibleElSelect>
                  </div>
                  <div>
                    <AccessibleElSelect
                      v-model="form.agrupacionOrganismo.value"
                      prop="agrupacionOrganismo"
                      :options="listGroupingOrganismosForAccessibleSelect"
                    >
                      <template slot="label">{{$t('grouping.neos_by_org')}}</template>
                    </AccessibleElSelect>
                  </div>
                </div>

                </template>
              </base-collapsible>
            </div>

            <div>
              <base-collapsible class="mb-3" customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{$t('configurations.email')}}</h2>
                  </div>
                </template>
                <template slot="content">

                  <div v-if="hasModuleAsignacionEmailReglas">
                    <span id="trash-notif-filter-email-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.email_vinculado')}}</span>
                      <el-form-item prop="email">
                        <el-input
                          aria-labelledby="trash-notif-filter-email-label"
                          class="w-full"
                          v-model="form.email.value"
                          maxlength="500"
                        >
                        <template v-if="form.email.value" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo del email"
                            @clear="form.email.value = ''"
                          />
                        </template>
                      </el-input>
                      </el-form-item>
                  </div>

                  <div>
                    <span id="trash-notif-filter-email-enviado-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.email_enviado')}}</span>
                      <el-form-item prop="emailEnviado">
                        <el-input
                          aria-labelledby="trash-notif-filter-email-enviado-label"
                          class="w-full"
                          v-model="form.emailEnviado.value"
                          maxlength="500"
                          >
                          <template v-if="form.emailEnviado.value" slot="suffix">
                            <base-clear-input-button
                              aria-label="Limpiar campo del email"
                              @clear="form.emailEnviado.value = ''"
                            />
                          </template>
                        </el-input>
                      </el-form-item>
                  </div>

                </template>
              </base-collapsible>
            </div>

            <div>
              <base-collapsible class="mb-3" customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{$t('app.api')}}</h2>
                  </div>
                </template>
                <template slot="content">

                  <div v-if="hasModuleAPIRequests">
                    <AccessibleElSelect
                      v-model="form.nombrePeticion.value"
                      prop="nombrePeticion"
                      :options="peticionesAPIForAccessibleSelect"
                    >
                      <template slot="label">{{$t('notificationFilter.notificacionesPeticionSpecific')}}</template>
                    </AccessibleElSelect>
                  </div>

                  <div v-if="hasModuleAPIRequests">
                    <AccessibleElSelect
                      v-model="form.enviadoPeticion.value"
                      prop="enviadoPeticion"
                      :options="archivadasForAccessibleSelect"
                    >
                      <template slot="label">{{$t('notificationFilter.notificacionesPeticion')}}</template>
                    </AccessibleElSelect>
                  </div>

                  <div v-if="hasModuleOrgProvinces">
                    <div>
                      <span id="trash-notif-filter-codigo-organismo-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('organismoprovincia.CodigoOrganismo')}}</span>
                      <el-form-item prop="CodigoOrganismo">
                        <el-input
                          aria-labelledby="trash-notif-filter-codigo-organismo-label"
                          class="w-full"
                          v-model="form.CodigoOrganismo.value"
                          maxlength="250"
                          >
                          <template v-if="form.CodigoOrganismo.value" slot="suffix">
                            <base-clear-input-button
                              aria-label="Limpiar campo del código de organismo"
                              @clear="form.CodigoOrganismo.value = ''"
                            />
                          </template>
                        </el-input>
                      </el-form-item>
                    </div>
                    
                    <div>
                      <span id="trash-notif-filter-nombre-organismo-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('organismoprovincia.NombreOrganismo')}}</span>
                      <el-form-item prop="NombreOrganismo">
                        <el-input
                          aria-labelledby="trash-notif-filter-nombre-organismo-label"
                          class="w-full"
                          v-model="form.NombreOrganismo.value"
                          maxlength="500"
                        >
                          <template v-if="form.NombreOrganismo.value" slot="suffix">
                            <base-clear-input-button
                              aria-label="Limpiar campo del nombre del organismo"
                              @clear="form.NombreOrganismo.value = ''"
                            />
                          </template>
                        </el-input>
                        </el-form-item>
                    </div>
                    
                    <div>
                      <span id="trash-notif-filter-codigo-provincia-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('organismoprovincia.CodigoProvincia')}}</span>
                      <el-form-item prop="CodigoProvincia">
                        <el-input
                          aria-labelledby="trash-notif-filter-codigo-provincia-label"
                          class="w-full"
                          v-model="form.CodigoProvincia.value"
                          maxlength="250"
                        >
                          <template v-if="form.CodigoProvincia.value" slot="suffix">
                            <base-clear-input-button
                              aria-label="Limpiar campo del código de provincia"
                              @clear="form.CodigoProvincia.value = ''"
                            />
                          </template>
                        </el-input>
                        </el-form-item>
                    </div>
                    
                    <div>
                      <span id="trash-notif-filter-nombre-provincia-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('organismoprovincia.NombreProvincia')}}</span>
                      <el-form-item prop="NombreProvincia">
                        <el-input
                          aria-labelledby="trash-notif-filter-nombre-provincia-label"
                          class="w-full"
                          v-model="form.NombreProvincia.value"
                          maxlength="500"
                        >
                          <template v-if="form.NombreProvincia.value" slot="suffix">
                            <base-clear-input-button
                              aria-label="Limpiar campo del nombre de la provincia"
                              @clear="form.NombreProvincia.value = ''"
                            />
                          </template>
                        </el-input>
                        </el-form-item>
                    </div>
                  </div>

                </template>
              </base-collapsible>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
// import _ from 'lodash'
import moment from 'moment'
// import { mapGetters } from 'vuex'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
import { getSedesByEmpresa } from '@/services/app/getSedesByEmpresa'
import { getLocations } from '@/services/app/getLocations'
import { getOrganismosByNEO } from '@/services/notifications/getOrganismosByNEO'
import { getCamposMetadatos } from '@/services/notifications/getCamposMetadatos'
import { i18n } from '@/i18n'
import { getDistributors } from '@/services/distributors/getDistributors'
import { getClients } from '@/services/clients/getClients'
import { TIPOS_ESTADO_DESCARGA } from '@/config/tipos-estado-descarga'
import { OPERADORES } from '@/config/operadores'
import { getGroupsNames } from '@/services/configurations/groups/getGroupsNames'

import { getAgrupacionesNombreCompanies } from '@/services/configurations/grouping/getAgrupacionesNombreCompanies'
import { getAgrupacionesNombreAgencies } from '@/services/configurations/grouping/getAgrupacionesNombreAgencies'
import { getAgrupacionesNombreLocations } from '@/services/configurations/grouping/getAgrupacionesNombreLocations'

import { getValoresMetadatoCliente } from '@/services/clients/getValoresMetadatoCliente' 
import { getPeticionesApiSimple } from '@/services/notifications/getPeticionesApiSimple' 

export default {
  name: 'filter-panel',
  components: {
    AccessibleElSelect
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    },
    status: {
      type: Number,
      default: 99999
    }
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      isOpen: this.panelOpen,
      loadingOrganismos: false,
      types: [],
      operators: OPERADORES,
      tiposEstadoDescarga: TIPOS_ESTADO_DESCARGA,
      form: {
        fechaDisposicionDesde: { label: 'F. disposición desde', value: '' },
        fechaDisposicionHasta: { label: 'F. disposición hasta', value: '' },
        fechaDescargaDesde: { label: 'F. descarga desde', value: '' },
        fechaDescargaHasta: { label: 'F. descarga hasta', value: '' },
        fechaFinTramiteDesde: { label: 'F. fin trámite desde', value: '' },
        fechaFinTramiteHasta: { label: 'F. fin trámite hasta', value: '' },
        fechaHoraRegistroDesde: { label: 'F. registro desde', value: '' },
        fechaHoraRegistroHasta: { label: 'F. registro hasta', value: '' },
        tipoNotif: { label: 'Tipo', value: '' },
        codPGN: { label: 'Sede', value: '' },
        estadoDescarga: { label: 'Estado', value: '' },
        estadoDescargaExtra: { label: 'Estado', value: '' },
        asunto: { label: 'Asunto', value: '' },
        idInterno: { label: 'Id Int', value: '' },
        textoLibre: { label: 'Contenido adjunto', value: '' },
        email: { label: i18n.t('configurations.email_vinculado'), value: '' },
        emailEnviado: { label: i18n.t('configurations.email_enviado'), value: '' },
        ultimoError: { label: 'Error temporal', value: '' },
        ticketId: { label: 'Ticket ID', value: '' },
        cif: { label: i18n.t('app.cif'), value: '' },
        cifTitular: { label: 'CIF Titular', value: '' },
        NombreCIF: { label: 'Razón social', value: '' },
        organismo: { label: 'Organismo', value: '' },
        nombreGrupo: { label: 'Grupo', value: '' },
        nombreGrupoPropietario: { label: i18n.t('notificationFilter.group_owner'), value: '' },  
        nombreGrupoPropietarioAnterior: { label: i18n.t('notificationFilter.group_owner_last'), value: '' },  
        TieneGrupoReparto: { label: i18n.t('notificationFilter.group_reparto'), value: '' },
        nombrePeticion: { label: i18n.t('notificationFilter.notificacionesPeticionSpecific'), value: '' },
        enviadoPeticion: { label: i18n.t('notificationFilter.notificacionesPeticion'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' },
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        notas: { label: i18n.t('notificationFilter.notas'), value: '' },
        metadato1: { 
          label: i18n.t('notificationFilter.metadato'), 
          value: {
            campo: '',
            valor: '',
            operador: '',
          } 
        },
        metadato2: { 
          label: i18n.t('notificationFilter.metadato'), 
          value: {
            campo: '',
            valor: '',
            operador: '',
          } 
        },
        metadato3: { 
          label: i18n.t('notificationFilter.metadato'), 
          value: {
            campo: '',
            valor: '',
            operador: '',
          } 
        },
        metadato4: { 
          label: i18n.t('notificationFilter.metadato'), 
          value: {
            campo: '',
            valor: '',
            operador: '',
          } 
        },
        metadato5: { 
          label: i18n.t('notificationFilter.metadato'), 
          value: {
            campo: '',
            valor: '',
            operador: '',
          } 
        },
        altaManual: { label: i18n.t('notificationFilter.alta_manual'), value: '' },
        DescargadaAutomaticamente: { label: i18n.t('notificationFilter.descargada_automaticamente'), value: '' },
        soyPropietario: { label: i18n.t('notificationFilter.soy_propietario'), value: '' },
        UsuarioResponsable: { label: i18n.t('app.user_responsable'), value: '' },
        agrupacionCIF: { label: i18n.t('grouping.neos_by_cif'), value: '' },
        agrupacionSede: { label: i18n.t('grouping.neos_by_sede'), value: '' },
        agrupacionOrganismo: { label: i18n.t('grouping.neos_by_org'), value: '' },
        CodigoOrganismo: { label: i18n.t('organismoprovincia.CodigoOrganismo'), value: '' },
        NombreOrganismo: { label: i18n.t('organismoprovincia.NombreOrganismo'), value: '' },
        CodigoProvincia: { label: i18n.t('organismoprovincia.CodigoProvincia'), value: '' },
        NombreProvincia: { label: i18n.t('organismoprovincia.NombreProvincia'), value: '' },
      },
      valoresMetadato1Actual: [],
      valoresMetadato2Actual: [],
      valoresMetadato3Actual: [],
      valoresMetadato4Actual: [],
      valoresMetadato5Actual: [],
      distribuidores: [],
      clientes: [],
      sedes: [],
      valuesOrganismos: [],
      valuesCamposMetadatos: [],
      valuesNombresGrupos: [],
      listGroupingEmpresas: [],
      listGroupingOrganismos: [],
      listGroupingSedes: [],
      peticionesAPI: [],
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ]
    }
  },
  computed: {
    valuesCamposMetadatosForAccessibleSelect () {
      return this.valuesCamposMetadatos.map(campo => ({ id: campo.value, value: campo.value, name: campo.label }))
    },
    valoresMetadato1ActualForAccessibleSelect () {
      return this.valoresMetadato1Actual.map(v => ({ id: v, value: v, name: v }))
    },
    valoresMetadato2ActualForAccessibleSelect () {
      return this.valoresMetadato2Actual.map(v => ({ id: v, value: v, name: v }))
    },
    valoresMetadato3ActualForAccessibleSelect () {
      return this.valoresMetadato3Actual.map(v => ({ id: v, value: v, name: v }))
    },
    valoresMetadato4ActualForAccessibleSelect () {
      return this.valoresMetadato4Actual.map(v => ({ id: v, value: v, name: v }))
    },
    valoresMetadato5ActualForAccessibleSelect () {
      return this.valoresMetadato5Actual.map(v => ({ id: v, value: v, name: v }))
    },
    distribuidoresForAccessibleSelect () {
      return this.distribuidores.map(d => ({ id: d.IdDistribuidor, value: d.Nombre, name: d.Nombre }))
    },
    clientesForAccessibleSelect () {
      return this.clientes.map(c => ({ id: c.IdEmpresa, value: c.Nombre, name: c.Nombre }))
    },
    typesForAccessibleSelect () {
      return this.types.map(t => ({ id: t.id, value: t.id, name: t.valor }))
    },
    tiposEstadoDescargaForAccessibleSelect () {
      return this.tiposEstadoDescarga.map(e => ({ id: e.id, value: e.id, name: e.Nombre }))
    },
    archivadasForAccessibleSelect () {
      return this.values.map(v => ({ id: v.value, value: v.value, name: v.label }))
    },
    listaGroupsGroupingForAccessibleSelect () {
      return this.listaGroupsGrouping.map(group => ({
        label: group.label,
        options: group.options.map(opt => ({ id: opt.value, value: opt.value, name: opt.label }))
      }))
    },
    listaGroupsGroupingOwnerForAccessibleSelect () {
      return this.listaGroupsGroupingOwner.map(group => ({
        label: group.label,
        options: group.options.map(opt => ({ id: opt.value, value: opt.value, name: opt.label }))
      }))
    },
    sedesForAccessibleSelect () {
      return this.sedes.map(sede => ({ id: sede.value, value: sede.value, name: sede.label }))
    },
    valuesOrganismosForAccessibleSelect () {
      return this.valuesOrganismos.map(org => ({ id: org.id, value: org.value, name: org.label }))
    },
    listGroupingEmpresasForAccessibleSelect () {
      return this.listGroupingEmpresas.map(item => ({ id: item, value: item, name: item }))
    },
    listGroupingSedesForAccessibleSelect () {
      return this.listGroupingSedes.map(item => ({ id: item, value: item, name: item }))
    },
    listGroupingOrganismosForAccessibleSelect () {
      return this.listGroupingOrganismos.map(item => ({ id: item, value: item, name: item }))
    },
    peticionesAPIForAccessibleSelect () {
      return this.peticionesAPI.map(pet => ({ id: pet.NombreAccion, value: pet.NombreAccion, name: pet.NombreAccion }))
    },
    hasModuleAPIRequests () {
      return this.$store.getters['auth/hasModuleAPIRequests']
    },
    hasModuleOrgProvinces () {
      return this.$store.getters['auth/hasModuleOrgProvinces']
    },
    hasModulePresentacionesAEAT () {
      return this.$store.getters['auth/hasModulePresentacionesAEAT']
    },
    hasModuleAsignacionEmailReglas () {
      return this.$store.getters['auth/hasModuleAsignacionEmailReglas']
    },
    hasModuleAgrupaciones () {
      return this.$store.getters['auth/hasModuleAgrupaciones']
    },
    hasModuleHotFolder () {
      return this.$store.getters['auth/hasModuleHotFolder']
    },
    listaGroupsGrouping () {
      if (this.valuesNombresGrupos.length > 0) {
        const options = []
        this.valuesNombresGrupos.forEach(x => {
          if (options.filter(y => y.label === x.Tipo).length === 0) {
            options.push(
              { label: x.Tipo, options: [] }
            )
          }
        })
        this.valuesNombresGrupos.forEach(x => {
          const index = options.map(x => x.label).indexOf(x.Tipo)
          options[index].options.push(
            {
              value: x.Nombre,
              label: x.Nombre,
            }
          )
        })
        return options
      }
      return []
    },
    listaGroupsGroupingOwner () {
      return this.listaGroupsGrouping.filter(x => x.label !== 'Reparto')
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    actualPath: function () {
      return this.$store.getters['app/actualRoute']
    },
    ultimoErrorActive: function () {
      return this.actualPath === '/' + process.env.VUE_APP_ROUTE_BASE + '/notifications/-3' || this.actualPath === '/' + process.env.VUE_APP_ROUTE_BASE + '/notifications/-1' || this.actualPath === '/' + process.env.VUE_APP_ROUTE_BASE + '/notifications/notices/error'
    },
    isGeneralStatus: function () {
      return this.status === undefined || this.status === null || this.status === '99999' || this.status === 99999
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  mounted: async function () {
    let locs
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      locs = await getLocations()
      if (locs.blnError === true) {
        this.doFeedback(locs.msgError + ' [Código de error: ' + locs.codError + ']')
      }

      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas
      if (this.role === 'SuperAdministrador') {
        const dataDistributors = await getDistributors()
        if (dataDistributors.blnError === true) {
          this.doFeedback(dataDistributors.msgError + ' [Código de error: ' + dataDistributors.codError + ']')
        }
        this.distribuidores = dataDistributors.Distribuidores
      }
    } else {
      locs = await getSedesByEmpresa()
      if (locs.blnError === true) {
        this.doFeedback(locs.msgError + ' [Código de error: ' + locs.codError + ']')
      }
    }
    if (locs.blnError === true) {
      throw locs
    } else {
      locs.PGNS.forEach(row => {
        this.sedes.push({ id: row.IdPGN, label: row.Nombre, value: row.Codigo })
      })
      this.sedes.unshift({ id: 0, value: 'Manual' })
      if (this.hasModuleHotFolder) this.sedes.unshift({ id: -1, value: 'Email' })
    }
    await this.$store.dispatch('app/getNotificationsTypes')
    this.types = await this.$store.getters['app/notificationsTypes']

    const gruposUsuario = await getGroupsNames()
    if (gruposUsuario.blnError) {
      this.doFeedback(gruposUsuario.msgError + ' [Código de error: ' + gruposUsuario.codError + ']')
    } else {
      this.valuesNombresGrupos = gruposUsuario.Respuesta
    }
    // Carga de campos de metadatos
    const metadatos = await getCamposMetadatos()
    if (metadatos.blnError) {
      this.doFeedback(metadatos.msgError + ' [Código de error: ' + metadatos.codError + ']')
    } else {
      metadatos.Respuesta.forEach(x => {
        const metadato = { value: x, label: x }
        this.valuesCamposMetadatos.push(metadato)
      })
    }
    if (this.hasModuleAgrupaciones) {
      const dataAgrupacionesEmpresas = await getAgrupacionesNombreCompanies()
      if (dataAgrupacionesEmpresas.blnError === true) {
        this.doFeedback(dataAgrupacionesEmpresas.msgError + ' [Código de error: ' + dataAgrupacionesEmpresas.codError + ']')
      }
      this.listGroupingEmpresas = dataAgrupacionesEmpresas.Respuesta

      const dataAgrupacionesOrganismos = await getAgrupacionesNombreAgencies()
      if (dataAgrupacionesOrganismos.blnError === true) {
        this.doFeedback(dataAgrupacionesOrganismos.msgError + ' [Código de error: ' + dataAgrupacionesOrganismos.codError + ']')
      }
      this.listGroupingOrganismos = dataAgrupacionesOrganismos.Respuesta

      const dataAgrupacionesSedes = await getAgrupacionesNombreLocations()
      if (dataAgrupacionesSedes.blnError === true) {
        this.doFeedback(dataAgrupacionesSedes.msgError + ' [Código de error: ' + dataAgrupacionesSedes.codError + ']')
      }
      this.listGroupingSedes = dataAgrupacionesSedes.Respuesta
    }

    if (this.hasModuleAPIRequests) {
      const dataApiRequests = await getPeticionesApiSimple()
      if (dataApiRequests.blnError) {
        this.doFeedback(dataApiRequests.msgError + ' [Código de error: ' + dataApiRequests.codError + ']')
      } else {
        this.peticionesAPI = dataApiRequests.respuesta
      }
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters['trashNotifications/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.fechaDisposicionDesde.value = _temp.fechaDisposicionDesde !== undefined && _temp.fechaDisposicionDesde.value !== '' ? _temp.fechaDisposicionDesde.value : ''
        this.form.fechaDisposicionHasta.value = _temp.fechaDisposicionHasta !== undefined && _temp.fechaDisposicionHasta.value !== '' ? _temp.fechaDisposicionHasta.value : ''
        this.form.fechaDescargaDesde.value = _temp.fechaDescargaDesde !== undefined && _temp.fechaDescargaDesde.value !== '' ? _temp.fechaDescargaDesde.value : ''
        this.form.fechaDescargaHasta.value = _temp.fechaDescargaHasta !== undefined && _temp.fechaDescargaHasta.value !== '' ? _temp.fechaDescargaHasta.value : ''
        this.form.fechaFinTramiteDesde.value = _temp.fechaFinTramiteDesde !== undefined && _temp.fechaFinTramiteDesde.value !== '' ? _temp.fechaFinTramiteDesde.value : ''
        this.form.fechaFinTramiteHasta.value = _temp.fechaFinTramiteHasta !== undefined && _temp.fechaFinTramiteHasta.value !== '' ? _temp.fechaFinTramiteHasta.value : ''
        this.form.fechaHoraRegistroDesde.value = _temp.fechaHoraRegistroDesde !== undefined && _temp.fechaHoraRegistroDesde.value !== '' ? _temp.fechaHoraRegistroDesde.value : ''
        this.form.fechaHoraRegistroHasta.value = _temp.fechaHoraRegistroHasta !== undefined && _temp.fechaHoraRegistroHasta.value !== '' ? _temp.fechaHoraRegistroHasta.value : ''
        this.form.tipoNotif.value = _temp.tipoNotif !== undefined && _temp.tipoNotif.value !== '' ? _temp.tipoNotif.value : ''
        this.form.codPGN.value = _temp.codPGN !== undefined && _temp.codPGN.value !== '' ? _temp.codPGN.value : ''
        this.form.estadoDescarga.value = _temp.estadoDescarga !== undefined && _temp.estadoDescarga.value !== '' ? _temp.estadoDescarga.value : ''
        this.form.estadoDescargaExtra.value = _temp.estadoDescargaExtra !== undefined && _temp.estadoDescargaExtra.value !== '' ? _temp.estadoDescargaExtra.value : ''
        this.form.asunto.value = _temp.asunto !== undefined && _temp.asunto.value !== '' ? _temp.asunto.value : ''
        this.form.idInterno.value = _temp.idInterno !== undefined && _temp.idInterno.value !== '' ? _temp.idInterno.value : ''
        this.form.textoLibre.value = _temp.textoLibre !== undefined && _temp.textoLibre.value !== '' ? _temp.textoLibre.value : ''
        this.form.email.value = _temp.email !== undefined && _temp.email.value !== '' ? _temp.email.value : ''
        this.form.emailEnviado.value = _temp.emailEnviado !== undefined && _temp.emailEnviado.value !== '' ? _temp.emailEnviado.value : ''
        this.form.ultimoError.value = _temp.ultimoError !== undefined && _temp.ultimoError.value !== '' ? _temp.ultimoError.value : ''
        this.form.ticketId.value = _temp.ticketId !== undefined && _temp.ticketId.value !== '' ? _temp.ticketId.value : ''
        this.form.cif.value = _temp.cif !== undefined && _temp.cif.value !== '' ? _temp.cif.value : ''
        this.form.cifTitular.value = _temp.cifTitular !== undefined && _temp.cifTitular.value !== '' ? _temp.cifTitular.value : ''
        this.form.NombreCIF.value = _temp.NombreCIF !== undefined && _temp.NombreCIF.value !== '' ? _temp.NombreCIF.value : ''
        this.form.organismo.value = _temp.organismo !== undefined && _temp.organismo.value !== '' ? _temp.organismo.value : ''
        this.form.nombreGrupo.value = _temp.nombreGrupo !== undefined && _temp.nombreGrupo.value !== '' ? _temp.nombreGrupo.value : ''
        this.form.nombreGrupoPropietario.value = _temp.nombreGrupoPropietario !== undefined && _temp.nombreGrupoPropietario.value !== '' ? _temp.nombreGrupoPropietario.value : ''
        this.form.nombreGrupoPropietarioAnterior.value = _temp.nombreGrupoPropietarioAnterior !== undefined && _temp.nombreGrupoPropietarioAnterior.value !== '' ? _temp.nombreGrupoPropietarioAnterior.value : ''
        this.form.TieneGrupoReparto.value = _temp.TieneGrupoReparto !== undefined && _temp.TieneGrupoReparto.value !== '' ? _temp.TieneGrupoReparto.value : ''
        this.form.nombrePeticion.value = _temp.nombrePeticion !== undefined && _temp.nombrePeticion.value !== '' ? _temp.nombrePeticion.value : ''
        this.form.enviadoPeticion.value = _temp.enviadoPeticion !== undefined && _temp.enviadoPeticion.value !== '' ? _temp.enviadoPeticion.value : ''
        this.form.empresa.value = _temp.empresa !== undefined && _temp.empresa.value !== '' ? _temp.empresa.value : ''
        this.form.distribuidor.value = _temp.distribuidor !== undefined && _temp.distribuidor.value !== '' ? _temp.distribuidor.value : ''
        this.form.notas.value = _temp.notas !== undefined && _temp.notas.value !== '' ? _temp.notas.value : ''
        this.form.metadato1.value = {
          campo: _temp.metadato1 !== undefined && _temp.metadato1.value !== undefined && _temp.metadato1.value.campo !== '' ? _temp.metadato1.value.campo: '',
          valor: _temp.metadato1 !== undefined && _temp.metadato1.value !== undefined && _temp.metadato1.value.valor !== '' ? _temp.metadato1.value.valor : '',
          operador: _temp.metadato1 !== undefined && _temp.metadato1.value !== undefined && _temp.metadato1.value.operador !== 1 ? _temp.metadato1.value.operador : 1,
        }
        this.form.metadato2.value = {
          campo: _temp.metadato2 !== undefined && _temp.metadato2.value !== undefined && _temp.metadato2.value.campo !== '' ? _temp.metadato2.value.campo: '',
          valor: _temp.metadato2 !== undefined && _temp.metadato2.value !== undefined && _temp.metadato2.value.valor !== '' ? _temp.metadato2.value.valor : '',
          operador: _temp.metadato2 !== undefined && _temp.metadato2.value !== undefined && _temp.metadato2.value.operador !== 1 ? _temp.metadato2.value.operador : 1,
        }
        this.form.metadato3.value = {
          campo: _temp.metadato3 !== undefined && _temp.metadato3.value !== undefined && _temp.metadato3.value.campo !== '' ? _temp.metadato3.value.campo: '',
          valor: _temp.metadato3 !== undefined && _temp.metadato3.value !== undefined && _temp.metadato3.value.valor !== '' ? _temp.metadato3.value.valor : '',
          operador: _temp.metadato3 !== undefined && _temp.metadato3.value !== undefined && _temp.metadato3.value.operador !== 1 ? _temp.metadato3.value.operador : 1,
        }
        this.form.metadato4.value = {
          campo: _temp.metadato4 !== undefined && _temp.metadato4.value !== undefined && _temp.metadato4.value.campo !== '' ? _temp.metadato4.value.campo: '',
          valor: _temp.metadato4 !== undefined && _temp.metadato4.value !== undefined && _temp.metadato4.value.valor !== '' ? _temp.metadato4.value.valor : '',
          operador: _temp.metadato4 !== undefined && _temp.metadato4.value !== undefined && _temp.metadato4.value.operador !== 1 ? _temp.metadato4.value.operador : 1,
        }
        this.form.metadato5.value = {
          campo: _temp.metadato5 !== undefined && _temp.metadato5.value !== undefined && _temp.metadato5.value.campo !== '' ? _temp.metadato5.value.campo: '',
          valor: _temp.metadato5 !== undefined && _temp.metadato5.value !== undefined && _temp.metadato5.value.valor !== '' ? _temp.metadato5.value.valor : '',
          operador: _temp.metadato5 !== undefined && _temp.metadato5.value !== undefined && _temp.metadato5.value.operador !== 1 ? _temp.metadato5.value.operador : 1,
        }
        this.form.altaManual.value = _temp.altaManual !== undefined && _temp.altaManual.value !== '' ? _temp.altaManual.value : ''
        this.form.DescargadaAutomaticamente.value = _temp.DescargadaAutomaticamente !== undefined && _temp.DescargadaAutomaticamente.value !== '' ? _temp.DescargadaAutomaticamente.value : ''
        this.form.soyPropietario.value = _temp.soyPropietario !== undefined && _temp.soyPropietario.value !== '' ? _temp.soyPropietario.value : ''
        this.form.UsuarioResponsable.value = _temp.UsuarioResponsable !== undefined && _temp.UsuarioResponsable.value !== '' ? _temp.UsuarioResponsable.value : ''
        this.form.agrupacionCIF.value = _temp.agrupacionCIF !== undefined && _temp.agrupacionCIF.value !== '' ? _temp.agrupacionCIF.value : ''
        this.form.agrupacionSede.value = _temp.agrupacionSede !== undefined && _temp.agrupacionSede.value !== '' ? _temp.agrupacionSede.value : ''
        this.form.agrupacionOrganismo.value = _temp.agrupacionOrganismo !== undefined && _temp.agrupacionOrganismo.value !== '' ? _temp.agrupacionOrganismo.value : ''
        this.form.CodigoOrganismo.value = _temp.CodigoOrganismo !== undefined && _temp.CodigoOrganismo.value !== '' ? _temp.CodigoOrganismo.value : ''
        this.form.NombreOrganismo.value = _temp.NombreOrganismo !== undefined && _temp.NombreOrganismo.value !== '' ? _temp.NombreOrganismo.value : ''
        this.form.CodigoProvincia.value = _temp.CodigoProvincia !== undefined && _temp.CodigoProvincia.value !== '' ? _temp.CodigoProvincia.value : ''
        this.form.NombreProvincia.value = _temp.NombreProvincia !== undefined && _temp.NombreProvincia.value !== '' ? _temp.NombreProvincia.value : ''
      }
    },
    // eslint-disable-next-line camelcase
    watchFormHandler: function ({ 
      tipoNotif, 
      fechaDisposicionDesde, 
      fechaDisposicionHasta, 
      fechaDescargaDesde, 
      fechaDescargaHasta, 
      fechaFinTramiteDesde, 
      fechaFinTramiteHasta, 
      fechaHoraRegistroDesde,
      fechaHoraRegistroHasta,
      estadoDescargaExtra, 
      codPGN, 
      altaManual,
    }) {
      // eslint-disable-next-line camelcase
      if (fechaDisposicionDesde.value !== undefined && moment(fechaDisposicionDesde.value).isValid()) {
        this.form.fechaDisposicionDesde.value = moment(fechaDisposicionDesde.value).format('YYYY-MM-DD[T00:00:00]')
      } else {
        this.form.fechaDisposicionDesde.value = ''
      }
      // eslint-disable-next-line camelcase
      if (fechaDisposicionHasta.value !== undefined && moment(fechaDisposicionHasta.value).isValid()) {
        this.form.fechaDisposicionHasta.value = moment(fechaDisposicionHasta.value).format('YYYY-MM-DD[T23:59:59]')
      } else {
        this.form.fechaDisposicionHasta.value = ''
      }
      // eslint-disable-next-line camelcase
      if (fechaDescargaDesde.value !== undefined && moment(fechaDescargaDesde.value).isValid()) {
        this.form.fechaDescargaDesde.value = moment(fechaDescargaDesde.value).format('YYYY-MM-DD[T00:00:00]')
      } else {
        this.form.fechaDescargaDesde.value = ''
      }
      // eslint-disable-next-line camelcase
      if (fechaDescargaHasta.value !== undefined && moment(fechaDescargaHasta.value).isValid()) {
        this.form.fechaDescargaHasta.value = moment(fechaDescargaHasta.value).format('YYYY-MM-DD[T23:59:59]')
      } else {
        this.form.fechaDescargaHasta.value = ''
      }
      // eslint-disable-next-line camelcase
      if (fechaFinTramiteDesde.value !== undefined && moment(fechaFinTramiteDesde.value).isValid()) {
        this.form.fechaFinTramiteDesde.value = moment(fechaFinTramiteDesde.value).format('YYYY-MM-DD[T00:00:00]')
      } else {
        this.form.fechaFinTramiteDesde.value = ''
      }
      // eslint-disable-next-line camelcase
      if (fechaFinTramiteHasta.value !== undefined && moment(fechaFinTramiteHasta.value).isValid()) {
        this.form.fechaFinTramiteHasta.value = moment(fechaFinTramiteHasta.value).format('YYYY-MM-DD[T23:59:59]')
      } else {
        this.form.fechaFinTramiteHasta.value = ''
      }
      // eslint-disable-next-line camelcase
      if (fechaHoraRegistroDesde.value !== undefined && moment(fechaHoraRegistroDesde.value).isValid()) {
        this.form.fechaHoraRegistroDesde.value = moment(fechaHoraRegistroDesde.value).format('YYYY-MM-DD[T00:00:00]')
      } else {
        this.form.fechaHoraRegistroDesde.value = ''
      }
      // eslint-disable-next-line camelcase
      if (fechaHoraRegistroHasta.value !== undefined && moment(fechaHoraRegistroHasta.value).isValid()) {
        this.form.fechaHoraRegistroHasta.value = moment(fechaHoraRegistroHasta.value).format('YYYY-MM-DD[T23:59:59]')
      } else {
        this.form.fechaHoraRegistroHasta.value = ''
      }
      if (estadoDescargaExtra.value !== undefined && estadoDescargaExtra.value !== '' && !Array.isArray(estadoDescargaExtra.value)) {
        this.form.estadoDescargaExtra.value = [estadoDescargaExtra.value]
      }
      if (codPGN.value !== undefined && codPGN.value !== '' && !Array.isArray(codPGN.value)) {
        this.form.codPGN.value = [codPGN.value]
      }
      if (altaManual !== undefined && altaManual.value) {
        this.form.altaManual.value = !!altaManual.value
      }
    },
    onChangeMetadato1 () {
      this.downloadListvalores(1, this.form.metadato1.value.campo) 
    },
    onChangeMetadato2 () {
      this.downloadListvalores(2, this.form.metadato2.value.campo) 
    },
    onChangeMetadato3 () {
      this.downloadListvalores(3, this.form.metadato3.value.campo) 
    },
    onChangeMetadato4 () {
      this.downloadListvalores(4, this.form.metadato4.value.campo) 
    },
    onChangeMetadato5 () {
      this.downloadListvalores(5, this.form.metadato5.value.campo) 
    },
    downloadListvalores: async function (valoresMetadatoActual, campoActual) {
      if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') return
      switch (valoresMetadatoActual) {
        case 1: this.valoresMetadato1Actual = []
          break
        case 2: this.valoresMetadato2Actual = []
          break
        case 3: this.valoresMetadato3Actual = []
          break
        case 4: this.valoresMetadato4Actual = []
          break
        case 5: this.valoresMetadato5Actual = []
          break
        default:
          break
      }
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { 
          Campo: campoActual, 
        }
        const response = await getValoresMetadatoCliente(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          switch (valoresMetadatoActual) {
            case 1: this.valoresMetadato1Actual = response.Respuesta 
              break
            case 2: this.valoresMetadato2Actual = response.Respuesta
              break
            case 3: this.valoresMetadato3Actual = response.Respuesta
              break
            case 4: this.valoresMetadato4Actual = response.Respuesta
              break
            case 5: this.valoresMetadato5Actual = response.Respuesta
              break
            default:
              break
          }
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        fechaDisposicionDesde: { label: 'F. disposición desde', value: '' },
        fechaDisposicionHasta: { label: 'F. disposición hasta', value: '' },
        fechaDescargaDesde: { label: 'F. descarga desde', value: '' },
        fechaDescargaHasta: { label: 'F. descarga hasta', value: '' },
        fechaFinTramiteDesde: { label: 'F. fin trámite desde', value: '' },
        fechaFinTramiteHasta: { label: 'F. fin trámite hasta', value: '' },
        fechaHoraRegistroDesde: { label: 'F. registro desde', value: '' },
        fechaHoraRegistroHasta: { label: 'F. registro hasta', value: '' },
        tipoNotif: { label: 'Tipo', value: '' },
        codPGN: { label: 'Sede', value: '' },
        estadoDescarga: { label: 'Estado', value: '' },
        estadoDescargaExtra: { label: 'Estado', value: '' },
        asunto: { label: 'Asunto', value: '' },
        idInterno: { label: 'Id Int', value: '' },
        email: { label: i18n.t('configurations.email_vinculado'), value: '' },
        emailEnviado: { label: i18n.t('configurations.email_enviado'), value: '' },
        textoLibre: { label: 'Contenido adjunto', value: '' },
        ultimoError: { label: 'Error temporal', value: '' },
        ticketId: { label: 'Ticket ID', value: '' },
        cif: { label: i18n.t('app.cif'), value: '' },
        cifTitular: { label: 'CIF Titular', value: '' },
        NombreCIF: { label: 'Razón social', value: '' },
        organismo: { label: 'Organismo', value: '' },
        nombreGrupo: { label: 'Grupo', value: '' },
        nombreGrupoPropietario: { label: i18n.t('notificationFilter.group_owner'), value: '' },
        nombreGrupoPropietarioAnterior: { label: i18n.t('notificationFilter.group_owner_last'), value: '' }, 
        TieneGrupoReparto: { label: i18n.t('notificationFilter.group_reparto'), value: '' },  
        nombrePeticion: { label: i18n.t('notificationFilter.notificacionesPeticionSpecific'), value: '' },
        enviadoPeticion: { label: i18n.t('notificationFilter.notificacionesPeticion'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' },
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        notas: { label: i18n.t('notificationFilter.notas'), value: '' },
        metadato1: { 
          label: i18n.t('notificationFilter.metadato'), 
          value: {
            campo: '',
            valor: '',
            operador: '',
          } 
        },
        metadato2: { 
          label: i18n.t('notificationFilter.metadato'), 
          value: {
            campo: '',
            valor: '',
            operador: '',
          } 
        },
        metadato3: { 
          label: i18n.t('notificationFilter.metadato'), 
          value: {
            campo: '',
            valor: '',
            operador: '',
          } 
        },
        metadato4: { 
          label: i18n.t('notificationFilter.metadato'), 
          value: {
            campo: '',
            valor: '',
            operador: '',
          } 
        },
        metadato5: { 
          label: i18n.t('notificationFilter.metadato'), 
          value: {
            campo: '',
            valor: '',
            operador: '',
          } 
        },
        altaManual: { label: i18n.t('notificationFilter.alta_manual'), value: '' },
        DescargadaAutomaticamente: { label: i18n.t('notificationFilter.descargada_automaticamente'), value: '' },
        soyPropietario: { label: i18n.t('notificationFilter.soy_propietario'), value: '' },
        UsuarioResponsable: { label: i18n.t('app.user_responsable'), value: '' },
        agrupacionCIF: { label: i18n.t('grouping.neos_by_cif'), value: '' },
        agrupacionSede: { label: i18n.t('grouping.neos_by_sede'), value: '' },
        agrupacionOrganismo: { label: i18n.t('grouping.neos_by_org'), value: '' },
        CodigoOrganismo: { label: i18n.t('organismoprovincia.CodigoOrganismo'), value: '' },
        NombreOrganismo: { label: i18n.t('organismoprovincia.NombreOrganismo'), value: '' },
        CodigoProvincia: { label: i18n.t('organismoprovincia.CodigoProvincia'), value: '' },
        NombreProvincia: { label: i18n.t('organismoprovincia.NombreProvincia'), value: '' },
      }
    },
    applyFilters: function () {
      this.cleanMultiples()
      // Limpia los filtros pares no completados
      this.cleanMetadatos()
      this.$store.commit('trashNotifications/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    cleanMetadatos () {
      // Si el operador es "Existe" añadimos valor "SI"
      if (this.form.metadato1.value.operador && this.form.metadato1.value.operador === 4) this.form.metadato1.value.valor = this.$i18n.t('app.yes')
      if (this.form.metadato2.value.operador && this.form.metadato2.value.operador === 4) this.form.metadato2.value.valor = this.$i18n.t('app.yes')
      if (this.form.metadato3.value.operador && this.form.metadato3.value.operador === 4) this.form.metadato3.value.valor = this.$i18n.t('app.yes')
      if (this.form.metadato4.value.operador && this.form.metadato4.value.operador === 4) this.form.metadato4.value.valor = this.$i18n.t('app.yes')
      if (this.form.metadato5.value.operador && this.form.metadato5.value.operador === 4) this.form.metadato5.value.valor = this.$i18n.t('app.yes')

      // Si el operador es "No Existe" añadimos valor "NO"
      if (this.form.metadato1.value.operador && this.form.metadato1.value.operador === 5) this.form.metadato1.value.valor = this.$i18n.t('app.no')
      if (this.form.metadato2.value.operador && this.form.metadato2.value.operador === 5) this.form.metadato2.value.valor = this.$i18n.t('app.no')
      if (this.form.metadato3.value.operador && this.form.metadato3.value.operador === 5) this.form.metadato3.value.valor = this.$i18n.t('app.no')
      if (this.form.metadato4.value.operador && this.form.metadato4.value.operador === 5) this.form.metadato4.value.valor = this.$i18n.t('app.no')
      if (this.form.metadato5.value.operador && this.form.metadato5.value.operador === 5) this.form.metadato5.value.valor = this.$i18n.t('app.no')

      if (!this.form.metadato1.value.valor || !this.form.metadato1.value.campo) {
        this.form.metadato1.value.valor = ''
        this.form.metadato1.value.campo = ''
      }
      if (!this.form.metadato2.value.valor || !this.form.metadato2.value.campo) {
        this.form.metadato2.value.valor = ''
        this.form.metadato2.value.campo = ''
      }
      if (!this.form.metadato3.value.valor || !this.form.metadato3.value.campo) {
        this.form.metadato3.value.valor = ''
        this.form.metadato3.value.campo = ''
      }
      if (!this.form.metadato4.value.valor || !this.form.metadato4.value.campo) {
        this.form.metadato4.value.valor = ''
        this.form.metadato4.value.campo = ''
      }
      if (!this.form.metadato5.value.valor || !this.form.metadato5.value.campo) {
        this.form.metadato5.value.valor = ''
        this.form.metadato5.value.campo = ''
      }
    },
    cleanMultiples: function () {
      if (Array.isArray(this.form.estadoDescargaExtra.value) && this.form.estadoDescargaExtra.value.length === 0) {
        this.form.estadoDescargaExtra.value = ''
      }
      if (Array.isArray(this.form.codPGN.value) && this.form.codPGN.value.length === 0) {
        this.form.codPGN.value = ''
      }
    },
    handleSelectSede: function (item) {
      this.form.idPGN.value = item.id
    },
    handleSelectTipo: function (item) {
      this.form.Tipo.value = item.id
    },
    handleSelectOrganismo: function (item) {
      this.form.organismo.value = item.id
    },
    handleSelectCliente: function (item) {
      this.form.empresa.value = item.id
    },
    handleSelectDistribuidor: function (item) {
      this.form.distribuidor.value = item.id
    },
    formatNombreOrg (element) {
      return element.Nombre + ' - ' + element.CIF
    },
    remoteOrganismos: async function (query) {
      this.valuesOrganismos = []
      if (query !== '' && this.loadingOrganismos === false && query.length > 2) {
        this.loadingOrganismos = true
        setTimeout(async () => {
          const organismos = await getOrganismosByNEO({ filtro: query })
          if (organismos.blnError === true) {
            this.doFeedback(organismos.msgError + ' [Código de error: ' + organismos.codError + ']')
          }
          if (organismos.DatosOrganismos !== undefined && organismos.DatosOrganismos?.length > 0) {
            let organismosMatch = []
            if (organismos.DatosOrganismos.length > 200) {
              organismosMatch = organismos.DatosOrganismos.filter(x => x.CIF.toUpperCase() === query.toUpperCase() || x.Nombre.toUpperCase() === query.toUpperCase())
              if (organismosMatch.length > 0) {
                this.doFeedback('Se han encontrado resultados coincidentes, pero se ha excedido el límite para los que contienen la búsqueda. Si el resultado esperado no aparece, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              } else {
                this.doFeedback('Se ha excedido el límite de resultados en la búsqueda. Por favor, introduzca más texto para acortar la búsqueda.', 'info', 5000)
              }
            } else {
              organismosMatch = organismos.DatosOrganismos
            }
            organismosMatch.forEach(element => {
              this.valuesOrganismos.push(
                { 
                  id: element.idOrganismo, 
                  value: element.Nombre,
                  label: this.formatNombreOrg(element),
                }
              )
            })
          }
          this.loadingOrganismos = false
        }, 200)
      } else {
        // this.options = []
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
